import React, { useRef, useState } from "react";
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyAddress = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);

    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // Function to handle file selection

    const [address, setAddress] = useState({
        current: selectedStaff?.staffDetails?.staff_bg_verification?.current_address,
        permanent: selectedStaff?.staffDetails?.staff_bg_verification?.permanent_address,
        status: selectedStaff?.staffDetails?.staff_bg_verification?.address_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.address_file || null
    });

    const [address1, setAddress1] = useState({
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.address_file || null
    });

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setAddress({ ...address, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setAddress1({ ...address1, verificationFile: fileURL }); // Update state with the file URL
        }
    };
    async function submitAddress() {
        // if (!address?.current || !address?.permanent || !address?.verificationFile) {
        //     openToast(" Provide either current or permanent address or upload file", "warning");
        //     return;
        // }

        setIsLoading(true);
        const newFormData = new FormData();
        newFormData.append("current_address", address?.current);
        newFormData.append("permanent_address", address?.permanent);
        newFormData.append("verificationFile", address?.verificationFile);

        try {
            const response = await fetch(baseUrl + "bg-verification/" + selectedStaff.staffDetails.id + "/verify/address", {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: newFormData
            });
            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setAddress({ ...address, current: result?.data?.current_address, permanent: result?.data?.permanent_address, status: result?.data?.address_status, verificationFile: result?.data?.address_file });
                openToast("Address successfully updated or created", "success");
                closeModal2();
            } else {
                openToast("An error occurred while adding or updating Address", "error");
            }
        } catch (error) {
            console.error("Error adding or updating Address:", error);
            openToast("An error occurred while adding or updating Address", "error");
        }
        finally {
            setIsLoading(false);
        }
    }


    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium'>Address Verification</h3>
                <button className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed animate-pulse')} onClick={submitAddress}>
                    Update Address
                </button>
            </div>

            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Address</h4>
                <div>
                    <p className='font-light'>{address.current}</p>
                    <p className='font-light'>{address.permanent}</p>
                </div>

                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{address.status}</p>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />

                <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {address1?.verificationFile ? (
                        typeof address1?.verificationFile === "string" ? (
                            <img
                                src={address1.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>
                <button className='second-btn' onClick={handleUploadClick}>
                    Upload
                </button>

            </div>


            <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add Address</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]'>Address
                        </label><br />
                        <input type='text' placeholder='Enter Current Address' className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={address.current} onChange={(e) => setAddress({ ...address, current: e.target.value })} /><br />
                        <label className='font-medium text-[13px] xl:text-[14px]'>Address2
                        </label><br />
                        <input type='text' placeholder="Enter Permanent Address" className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={address.permanent} onChange={(e) => setAddress({ ...address, permanent: e.target.value })} /><br />


                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn' onClick={closeModal2}>Save </button>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default VerifyAddress